export default (completedTours) => (dispatch, getState) => 
  dispatch({type:'save_completed_tours', completedTours})



/** WEBPACK FOOTER **
 ** ./app/actions/saveCompletedTours.js
 **/